// Partage d'un lien : feuille de partage native (mobile) si disponible,
// sinon copie dans le presse-papiers. Renvoie 'shared', 'copied' ou null.
export async function shareLink({ title, text, url }) {
    if (navigator.share) {
        try {
            await navigator.share({ title, text, url })
            return 'shared'
        } catch (error) {
            // Partage annulé par l'utilisateur : rien d'autre à faire
            if (error?.name === 'AbortError') return null
        }
    }

    try {
        await navigator.clipboard.writeText(url)
        return 'copied'
    } catch {
        return null
    }
}
